import { render } from "./BlocoComercial.vue?vue&type=template&id=4656e3f1"
import script from "./BlocoComercial.vue?vue&type=script&lang=js"
export * from "./BlocoComercial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__